import React, { useContext } from 'react';
import Axios from 'axios';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment, faTrash } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';

import { AuthContext } from '../../../../../Data/AuthContext';
import { registrationStateToString } from '../../../../../Utils/Converters';

import './Task.css';

function TaskRegistration(props) {
    const auth = useContext(AuthContext);

    const { id, userName, state, remark, userId, taskId, taskEventId } = props.taskReg;

    function deleteRegistration() {
        Axios.delete(`/events/${taskEventId}/tasks/${taskId}/registrations/${id}`)
            .then(() => {
                toast.success(`Jelentkezés törölve.`);
                props.callback();
            }, () => {
                toast.error(`A jelentkezés törölése nem sikerült.`);
            });
    }

    return (
        <div>
            {userName} ({registrationStateToString(state)})
            {remark ? <span> <FontAwesomeIcon icon={faComment} /> {remark}</span> : null}
            {userId === auth.userId && <Button color="warning" size="sm" onClick={deleteRegistration} type="button"><FontAwesomeIcon icon={faTrash} /> Lemondás</Button>}
        </div>
    );
}

export default TaskRegistration;